module.exports = __webpack_public_path__ + "assets/img/big-logo.f385ea8d.png";